import * as React from "react";

import { Page, PageHero, Tabs } from "src/components/common";

interface IProps {
	children?: any;
	match?: any;
	location?: any;
}

const ProfileTabs: React.FC<IProps> = (props) => {
	const tabs = [
		{
			id: 1,
			label: "Settings",
			to: "/profile/settings",
		},
		{
			id: 2,
			label: "Change password",
			to: "/profile/password",
		},
	];

	return (
		<React.Fragment>
			<div className="alert alert-info m-3" role="alert">
				This page is currently under development. Not all features might work
				yet.
			</div>
			<Page>
				<PageHero>
					<h1 className="mb-0">Profile Details</h1>
				</PageHero>
				<Tabs className="mb-4" tabs={tabs} location={props.location} />
				{props.children}
			</Page>
		</React.Fragment>
	);
};

export default ProfileTabs;
